import axios from 'axios';
import * as Constants from "../constants/Constants";

export function contactForm(payload) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(
        Constants.REACT_APP_API_URL +
        // process.env.REACT_APP_API_VERSION +
        "api/" +
        Constants.CONTACT_API_ROUTE,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            "Accept": "application/json"
          },
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function careerForm(payload) {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    Object.keys(payload).forEach(key => {
      if (key !== 'resume' && key !== 'skills') {
        formData.append(key, payload[key]);
      }
    });
    payload.skills.forEach((skill, index) => {
      formData.append(`skills[${index}]`, skill);
    });

    // Append resume file
    if (payload.resume) {
      formData.append('resume', payload.resume);
    }
    axios
      .post(
        Constants.REACT_APP_API_URL +
        // process.env.REACT_APP_API_VERSION +
        "api/" +
        Constants.CAREER_API_ROUTE,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function quoteForm(payload) {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    Object.keys(payload).forEach(key => {
      if (key === 'file') {
        formData.append(key, payload[key]);
      } else {
        formData.append(key, payload[key]);
      }
    });
    axios
      .post(
        Constants.REACT_APP_API_URL +
        "api/" +
        Constants.QUOTE_API_ROUTE,
        formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// export function careerForm(payload) {
//   return new Promise(async (resolve, reject) => {
//     axios
//       .post(
//         Constants.REACT_APP_API_URL +
//         // process.env.REACT_APP_API_VERSION +
//         "api/" +
//         Constants.CAREER_API_ROUTE,
//         payload,
//         {
//           headers: {
//             "content-type": Constants.CONTANT_TYPE,
//           },
//           withCredentials: true,
//         }
//       )
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }

// export function quoteForm(payload) {
//   return new Promise(async (resolve, reject) => {
//     axios
//       .post(
//         Constants.REACT_APP_API_URL +
//         // process.env.REACT_APP_API_VERSION +
//         "api/" +
//         Constants.QUOTE_API_ROUTE,
//         payload,
//         {
//           headers: {
//         "Content-Type": "multipart/form-data",
//           },
//           withCredentials: true,
//         }
//       )
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//           console.error('Error:', error);
//         reject(error);
//       });
//   });
// }